module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (162).513f3481.jpg";